import { RESTproxy } from '../RESTproxy';

export class FacetVocabProxy extends RESTproxy {
    constructor() {
        super('catalog/facet-vocab');
    }
}

let cached = null;

/** Fetch-once facet vocabulary; a failed fetch clears the cache for a retry. */
export const loadFacetVocab = () => {
    if (!cached) {
        cached = new FacetVocabProxy().list().catch((e) => {
            cached = null;
            throw e;
        });
    }
    return cached;
};
